import React, { useState, useEffect } from "react";
import { productAPI } from "../../Handlers/productAPI";
import { adminCategoryAPI } from "../../../Handlers/categoryAPI";
import styles from '../../styles/components/forms/productForm.module.css';

function ProductForm({ onSuccess }) {
    const [file, setFile] = useState(null);
    const [preview, setPreview] = useState(null);
    const [loading, setLoading] = useState(false);
    const [categories, setCategories] = useState([]);

    const [productData, setProductData] = useState({
        name: '', price: '', description: '', stock: 0,
        featured: false, options: '',
        weight: 0.500, width: 15, height: 15, length: 15,
        category_id: ''
    });

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await adminCategoryAPI.list();
                setCategories(response || []); 
            } catch (error) {
                console.error("Erro ao buscar categorias:", error);
            }
        };
        fetchCategories();
    }, []);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setProductData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            setPreview(URL.createObjectURL(selectedFile));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!productData.category_id) {
            alert("Por favor, selecione uma categoria.");
            return;
        }

        setLoading(true);
        try {
            const data = new FormData();
            Object.keys(productData).forEach(key => data.append(key, productData[key]));
            if (file) data.append('image_file', file);

            const response = await productAPI.create(data);
            onSuccess(response);
            
            // Reset
            setProductData({ 
                name: '', price: '', description: '', stock: 0, 
                featured: false, options: '', weight: 0.500, 
                width: 15, height: 15, length: 15, category_id: '' 
            });
            setPreview(null);
            setFile(null);
        } catch (error) {
            alert("Erro ao cadastrar produto.");
        } finally { setLoading(false); }
    };

    return (
        <form onSubmit={handleSubmit} className={styles.formContainer}>
            <h2 className={styles.title}>Novo Produto</h2>

            <div className={styles.group}>
                <label htmlFor="name">Identificação</label>
                <input 
                    id="name"
                    className={styles.input} 
                    name="name" 
                    value={productData.name} 
                    onChange={handleChange} 
                    placeholder="Nome do produto" 
                    required 
                />
            </div>

            <div className={styles.group}>
                <label htmlFor="category_id">Categoria</label>
                <select 
                    id="category_id"
                    className={styles.input} 
                    name="category_id" 
                    value={productData.category_id} 
                    onChange={handleChange} 
                    required
                >
                    <option value="">Selecione uma categoria...</option>
                    {categories.map((cat) => (
                        <option key={cat.id} value={cat.id}>
                            {cat.name}
                        </option>
                    ))}
                </select>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                <div className={styles.group}>
                    <label htmlFor="price">Preço (R$)</label>
                    <input 
                        id="price"
                        className={styles.input} 
                        name="price" 
                        type="number" 
                        step="0.01" 
                        value={productData.price} 
                        onChange={handleChange} 
                        required 
                    />
                </div>
                <div className={styles.group}>
                    <label htmlFor="stock">Estoque Disponível</label>
                    <input 
                        id="stock"
                        className={styles.input} 
                        name="stock" 
                        type="number" 
                        value={productData.stock} 
                        onChange={handleChange} 
                        required 
                    />
                </div>
            </div>

            <div className={styles.logisticSection}>
                <span className={styles.logisticTitle}>📦 Dimensões de Logística (Melhor Envio)</span>
                <div className={styles.logisticGrid}>
                    <div className={styles.group}>
                        <label>Peso (kg)</label>
                        <input className={styles.input} name="weight" type="number" step="0.001" value={productData.weight} onChange={handleChange} required />
                    </div>
                    <div className={styles.group}>
                        <label>Largura (cm)</label>
                        <input className={styles.input} name="width" type="number" value={productData.width} onChange={handleChange} required />
                    </div>
                    <div className={styles.group}>
                        <label>Altura (cm)</label>
                        <input className={styles.input} name="height" type="number" value={productData.height} onChange={handleChange} required />
                    </div>
                    <div className={styles.group}>
                        <label>Comprimento (cm)</label>
                        <input className={styles.input} name="length" type="number" value={productData.length} onChange={handleChange} required />
                    </div>
                </div>
            </div>

            <div className={styles.imageUploadGroup}>
                {preview ? (
                    <img src={preview} alt="Preview" className={styles.previewImage} />
                ) : (
                    <div style={{ fontSize: '2rem', color: '#d2d2d7' }}>🖼️</div>
                )}
                <label className={styles.uploadLabel}>
                    {preview ? 'Alterar Imagem' : 'Selecionar Imagem Principal'}
                    <input type="file" hidden onChange={handleFileChange} accept="image/*" />
                </label>
            </div>

            <button type="submit" className={styles.submitButton} disabled={loading}>
                {loading ? 'Salvando informações...' : 'Cadastrar Produto'}
            </button>
        </form>
    );
}

export default ProductForm;